import React from 'react';
import ErrorText from '../../artzu-ui/src/TextBox/ErrorText';

const MessageBox = ({
  disabled,
  placeholder,
  heading,
  onChange,
  error,
  ...props
}) => (
  <div>
    <p className="contact-input-heading">
      <div className="required-header">
        {heading}
        {heading !== 'Phone' && <div className="required-field">*</div>}
      </div>
    </p>
    <textarea
      {...props}
      className="contact-messageBox"
      placeholder={placeholder}
      onChange={evt => onChange(evt)}
    />
    {error && <ErrorText error={error} />}
  </div>
);

export default MessageBox;



// WEBPACK FOOTER //
// ./src/components/NewContact/MessageBox.js